import { GetNextPagePayload } from '../../types/Navigation/GetNextPagePayload';
import { setDisabledPages } from './utilities/setDisabledPages';

export const getNextPage = async (payload: GetNextPagePayload) => {
  const { currentPage, patientInfo } = payload;

  if (currentPage === 'selfPay' && patientInfo.navObj['thanks'].disabled) {
    return patientInfo.navObj['selfPay'].path;
  }

  // TURN THE NAVIGATION OBJECT INTO AN ARRAY
  const navArray = Object.entries(patientInfo.navObj).map(([key, value]) => {
    return { [key]: { ...value } };
  });

  // SORT THE ARRAY BY BASE ORDER
  navArray.sort((a, b) => {
    return a[Object.keys(a)[0]].baseOrder - b[Object.keys(b)[0]].baseOrder;
  });

  // HIDE PAGES BASED ON PATIENT INFO (WILL NOT APPEAR IN NAV MENU)
  await setDisabledPages(patientInfo, payload.chart);

  // // THIS LOGIC IS NECESSARY FOR THE THANKS PAGE, WHICH MIGHT ALREADY BE DISABLED OR COMPLETED WHEN IT IS THE CURRENT PAGE
  // if (currentPage === 'thanks' || currentPage === 'files') {
  //   const currentPageIndex = navArray.findIndex((navItem) => {
  //     return Object.keys(navItem)[0] === currentPage;
  //   });
  //   const nextPageObj = navArray[currentPageIndex + 1];
  //   const nextPagePath = nextPageObj ? nextPageObj[Object.keys(nextPageObj)[0]].path : '';
  //   return nextPagePath;
  // }

  // FILTER OUT THE PAGES THAT ARE COMPLETED OR DISABLED
  // TODO: MAYBE ALLOW COMPLETED PAGES???
  const filteredNavArray = navArray.filter((navItem) => {
    const key = Object.keys(navItem)[0];
    const value = navItem[key];
    return !value.completed && !value.disabled;
  });

  // FIND THE CURRENT PAGE
  const currentPageIndex = filteredNavArray.findIndex((navItem) => {
    return Object.keys(navItem)[0] === currentPage;
  });

  // RETURN THE NEXT PAGE IN THE ARRAY
  const nextPageObj = filteredNavArray[currentPageIndex + 1];
  const nextPagePath = nextPageObj ? nextPageObj[Object.keys(nextPageObj)[0]].path : '';
  return nextPagePath;
};
